import axios from 'axios';
import ViewUI from 'view-design';
// 添加请求拦截器
var timer
axios.interceptors.request.use(function(config) {
  

    return config;
}, function(error) {
   
    // 对请求错误做些什么
    return Promise.reject(error);
});

// 添加响应拦截器
axios.interceptors.response.use(function(response) {
    // 对响应数据做点什么

    timer = null
    return response;
}, function(error) {
    // 对响应错误做点什么
    // this.$Message.error(error);
    console.log(error);
    var str=error.toString()
    if(str.search(/Request/i) !=-1){
       
        return Promise.reject('网络异常，请核查请求结果；');
    }else if(str.search(/Network/i) !=-1){
        return Promise.reject('网络错误，请求失败；');
    }else if(str.search(/timeout /i) !=-1){
        // ViewUI.$Message.error('!!!!!!!!!!!!!!!!!请求超时，请核查请求结果！');
        return Promise.reject('请求超时，请核查请求结果！');
    }
    else{
        return Promise.reject(str);
    }
    
});
export default axios;


// WEBPACK FOOTER //
// ./src/api/axios.js